import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';

import { GeneralInfo, JobTasks, Sales, Credibility, Summary } from './Detail';

const styles = theme => ({
  root: {
  },
  card: {
  },
  content: {
    padding: '0px',
  }
});

const BidsDetail = ({ classes, bid, preview = false }) => {
  return(
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <GeneralInfo heading="Quote" preview={preview} />
          <Sales preview={preview} />
          <JobTasks type="estimate" preview={preview} />
          <Summary preview={preview} />
          <Credibility preview={preview} />
        </CardContent>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => ({
  bid: state.bidsState.find( bid => bid.id === state.adminState.bid.id ),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(BidsDetail);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidsDetail.jsx